import * as React from "react";
const SvgDotOutlineGray = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 7, cy: 7, r: 6.5, stroke: "#8690A1" }));
export default SvgDotOutlineGray;
